import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  panel: {
    width: '100%',
  },
  filtersPanelHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  filtersPanelTitle: {
    color: Theme.palette.primary.main,
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[6],
    lineHeight: '125%',
  },
  clearFiltersButton: {
    fontFamily: Theme.typography.base.regular,
    color: Theme.palette.primary.light,

    margin: 0,
    [Theme.breakpoints.up('xs')]: {
      fontSize: Theme.typography.size[2],
      lineHeight: '150%',
    },
    [Theme.breakpoints.up('md')]: {
      fontSize: Theme.typography.size[1],
      lineHeight: '125%',
    },
  },
  filterContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '48px',

    '& .time-header': {
      display: 'flex',

      '& svg': {
        width: 16,
      },
    },
  },
  filterName: {
    color: Theme.palette.primary.main,
    fontFamily: Theme.typography.base.semiBold,
    lineHeight: '150%',
    marginBottom: '10px',
    [Theme.breakpoints.up('xs')]: {
      fontSize: Theme.typography.size[3],
    },
    [Theme.breakpoints.up('md')]: {
      fontSize: Theme.typography.size[2],
    },
  },
  filterContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  filterText: {
    color: Theme.palette.gray[750],
    fontSize: Theme.typography.size[2],
    fontFamily: Theme.typography.base.regular,
    lineHeight: '150%',
  },
  filterTextDisabled: {
    color: Theme.palette.gray[400],
  },
  checkboxFilterContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '10px',
    [Theme.breakpoints.up('xs')]: {
      marginBottom: '26px',
    },
    [Theme.breakpoints.up('md')]: {
      marginBottom: '10px',
    },
    '&:last-child': {
      marginBottom: 0,
    },
  },
  checkboxButton: {
    color: `${Theme.palette.gray[500]}  !important`,
    padding: 0,
    [Theme.breakpoints.down('sm')]: {
      transform: 'scale(1.25)',
    },
    '&.Mui-checked': {
      color: `${Theme.palette.primary.light} !important`,
    },
  },
  checkboxButtonDisabled: {
    color: `${Theme.palette.gray[300]} !important`,
  },
  sliderContainer: {
    marginTop: '4px',

    '& .MuiSlider-root': {
      color: Theme.palette.primary.light,
    },
  },
  disabledSliderContainer: {
    marginTop: '28px',
  },
  takeOffTimeSliderContainer: {
    marginBottom: '20px',
  },
  datesRangeText: {
    color: Theme.palette.gray[750],
    fontSize: Theme.typography.size[1],
    fontFamily: Theme.typography.base.regular,
    lineHeight: '150%',
  },
}));

export default useStyles;
